import type { ListingResponse } from "@hybrid-escrow/shared";
import { apiBaseUrl } from "../lib/env";

/** The seller's cover image, or nothing when there isn't one. `updatedAt` is the cache-buster:
 *  the API serves covers with a one-hour max-age, and replacing one bumps the listing's
 *  updatedAt. */
export function ListingCover({
  listing,
  className,
}: {
  listing: Pick<ListingResponse, "id" | "title" | "hasCoverImage" | "updatedAt">;
  className?: string;
}) {
  if (!listing.hasCoverImage) return null;
  return (
    <img
      className={className ?? "listing-cover"}
      src={`${apiBaseUrl}/api/v1/listings/${listing.id}/cover?v=${encodeURIComponent(listing.updatedAt)}`}
      alt={listing.title}
    />
  );
}
